<div class="row dashboardBlock">
  <div class="col-12">
    <div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
      <div class="col-sm-2 col-md-3 padding-menu">
        <div class="actionItemsList">
          <ul>
            <ng-container *ngFor="let item of actionItemsList; let i = index">
              <li *ngIf="item.isShow"
                [ngClass]="item.isActive ? (isArabic ? 'active arabicAlign' : 'active') : (isArabic ? 'cursor-pointer arabicAlign' : 'cursor-pointer')"
                (click)="onListItemClick(i)">
                <span class="stepNumber">
                  <img [src]="item.img" alt="" />
                </span>
                <!-- <span class="stepNumber"
                                    [ngClass]="(item.link == 'cases' || item.link == 'resources') ? 'smallPadding' : ''">
                                    <img [src]="item.img" alt=""
                                        [ngClass]="(item.link == 'cases' || item.link == 'resources') ? 'bigImg' : ''" />
                                </span> -->
                <span class="stepText" *ngIf="!isArabic">{{ item.value }}</span>
                <span class="stepText" *ngIf="isArabic">{{ item.arabicValue }}</span>
                <div *ngIf="item.link == 'action-items/rejected' && rejectedCount>0" class="item-count"
                  [ngClass]="isArabic ? 'arabicCount' : ''">{{rejectedCount}}</div>
                <div *ngIf="item.link == 'action-items/pending' && pendingCount>0" class="item-count"
                  [ngClass]="isArabic ? 'arabicCount' : ''">{{pendingCount}}</div>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
      <div class="col-sm-10 col-md-9 assessment-right">
        <div><router-outlet (activate)="subscribeToEmitter($event)"></router-outlet></div>
        <div class="startBtnDiv" *ngIf="ifPendingActionItem || ifRejectedActionItem"
          [ngClass]="isArabic ? 'col-md-4' : 'offset-md-8 col-md-4'">
          <button type="submit" class="btn-lg btn-primary ratButton rightBtn nextButton"
            [ngClass]="(actionItem == null || actionItem == undefined) ? 'disabledBtn' : ''" (click)="goToActionItem()"
            [disabled]="actionItem == null || actionItem == undefined">
            <ng-container>
              <span *ngIf="!isArabic">VIEW PLAN</span>
              <span *ngIf="isArabic">عرض الخطة</span>
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>